import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="w-full bg-white" data-id="element-151">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-6" data-id="element-153">
          <p className="text-lg sm:text-xl text-gray-700 leading-relaxed" data-id="element-154">
            Faltan pocos días para tu cita en USCIS y el nudo en el estómago no
            te deja dormir. Sabes que te has esforzado, pero el miedo a quedarte
            en blanco frente al oficial o no entender una pregunta técnica te
            persigue.
          </p>

          <p className="text-xl sm:text-2xl font-semibold text-[#1B2A4A]" data-id="element-155">
            No es que no sepas la historia de este país; es que nadie te ha
            enseñado a responder con la seguridad de un ciudadano.
          </p>
        </motion.div>
      </div>
    </section>;
}